import { Component, OnInit } from '@angular/core';
import {LineaTService} from '../services/lineaT.service';
import { ModalService } from '../services/modal.service';
import {InicioFaces} from '../interfaces/inicioFaces';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { AlertsService } from 'angular-alert-module';


@Component({
selector: 'app-lineaT',
templateUrl: './lineaT.component.html',
styleUrls: ['./lineaT.component.css']
})
export class LineaTComponent implements OnInit {

inicioConducta: InicioFaces[];
inicioDept: InicioFaces[];
inicioMunp: InicioFaces[];
inicioTipoVincu: InicioFaces[];
inicioAgregar:any =[];
denuncia: any = {};
denunciaFrom: FormGroup;
fileData: File = null;
fileUploadProgress: string = null;
uploadedFilePath: string = null;
previewUrl:any = null;
submitted = false;



constructor(private lineaTservice: LineaTService,private httpClient: HttpClient,private formBuilder: FormBuilder, private alerts: AlertsService, private modalService: ModalService) { }



listarConducta() {    
    this.lineaTservice.mostrarConducta().subscribe((data: any) => {
    this.inicioConducta = data.obj;
    return;
    },
    (error) => {
    alert('Ocurrio un Error');
    console.log("imprimir", error);
    });
    }

listarTipoVinculacion() {    
    this.lineaTservice.mostrarTipoVinculacion().subscribe((data: any) => {
    this.inicioTipoVincu = data.obj;
     return;
    },
    (error) => {
        alert('Ocurrio un Error');
        console.log("imprimir", error);
    });
}

listarDept() {    
 this.lineaTservice.mostrarDept().subscribe((data: any) => {
    this.inicioDept = data.obj;
     return;
    },
        (error) => {
        alert('Ocurrio un Error');
        console.log("imprimir", error);
    });
}

onOptionsSelected(){
   this.listarMunp(this.denuncia.deptid);
}

probrar(){
   console.log('dime qeu pasooo',this.denuncia);
 }
onDePersona(idx){
    this.inicioAgregar.splice(idx,1);    
    
 }

agregarpersonas(){
    this.inicioAgregar.push({nombre: this.denuncia.nombrePersona, cargo: this.denuncia.cargoPersona, adiccion: this.denuncia.adiccionPersona});
    this.denuncia.nombrePersona = '';
    this.denuncia.cargoPersona = '';
    this.denuncia.adiccionPersona = '';

}
listarMunp(deptid) {    
    console.log("si entro 789");
    this.lineaTservice.mostrarMunp(deptid).subscribe((data: any) => {
       this.inicioMunp = data.obj;
        return;
       },
           (error) => {
           alert('Ocurrio un Error');
           console.log("imprimir", error);
       });
   }

   onDenuncia() {
    this.submitted = true;
        
  
        const formData = new FormData();
       
             formData.append('file', this.fileData);  
             formData.append('denunciaid', this.denuncia.denunciaid),
             formData.append('descripcion', this.denuncia.descripcion),
             formData.append('areaSuceso', this.denuncia.areaSuceso),
             formData.append('deptid', this.denuncia.deptid),
             formData.append('munpid', this.denuncia.munpid),
             formData.append('fechaConducta', this.denuncia.fechaConducta),
             formData.append('opcionAnonimo', this.denuncia.opcionAnonimo),
             formData.append('vinculacionid', this.denuncia.vinculacionid),
             formData.append('nombrePersonaDenuncia', this.denuncia.nombrePersonaDenuncia),
             formData.append('celularPersonaDenuncia', this.denuncia.celularPersonaDenuncia),
             formData.append('emailPersonaDenuncia', this.denuncia.emailPersonaDenuncia),
             formData.append('personasImplicadas', JSON.stringify(this.inicioAgregar)),
      
  
        this.fileUploadProgress = '0%';
        if(this.denunciaFrom.valid) {
            this.lineaTservice.insertDenuncias(formData, this.denuncia).subscribe(events => {
                this.modalService.open('custom-modal-2');
                this.limpiarCampos();
            })
                 
          } else {
            this.modalService.open('custom-modal-3');
          }
           
   
    }

    limpiarCampos(){
        this.denuncia = {};
  
      }

 
 fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
}

closeModal(id: string) {
    this.modalService.close(id);
}
preview() {
    // Show preview
      var mimeType = this.fileData.type;
      if (mimeType.match(/image\/*/) == null) {
          return;
     }
  
      var reader = new FileReader();      
      reader.readAsDataURL(this.fileData);
      reader.onload = (_event) => {
         this.previewUrl = reader.result;
       }
    }

ngOnInit() {
    this.listarConducta();
    this.denuncia.opcionAnonimo = false;
    this.listarDept();
    this.listarTipoVinculacion();
    this.denunciaFrom = this.formBuilder.group({
        denunciaid: ['', Validators.required],
        descripcion: ['', Validators.required],
        deptid: ['', Validators.required],
        munpid: ['', Validators.required],
        fechaConducta:['',Validators.required],
        vinculacionid:['',Validators.required],
        areaSuceso:['',Validators.required],
        });
}

}

